// extracted by mini-css-extract-plugin
export default {"stepperContainer":"FormStepper_stepperContainer__xJS-q"};